import { render, staticRenderFns } from "./DataTableFooterIcon.vue?vue&type=template&id=29e6858a&scoped=true&"
import script from "./DataTableFooterIcon.vue?vue&type=script&lang=js&"
export * from "./DataTableFooterIcon.vue?vue&type=script&lang=js&"
import style0 from "./DataTableFooterIcon.vue?vue&type=style&index=0&id=29e6858a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e6858a",
  null
  
)

export default component.exports